import { render } from "./BtnChallenge.vue?vue&type=template&id=11331e02&scoped=true"
import script from "./BtnChallenge.vue?vue&type=script&lang=js"
export * from "./BtnChallenge.vue?vue&type=script&lang=js"

import "@/css/components/btn-challenge.css?vue&type=style&index=0&id=11331e02&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11331e02"]])

export default __exports__